import * as React from 'react';
import * as styles from './SafeRentPopup.css';

export const SafeRentPopup = () => (
  <div className={styles['container']}>
    <h3 className={styles['title']}>
      Безопасная аренда от ЦИАН
    </h3>
    <ul className={styles['list']}>
      <li>Собственник предоставил подтверждение права собственности.</li>
      <li>Звонки по объявлению принимает сотрудник ЦИАН.</li>
      <li>Предоставим грамотный шаблон договора аренды.</li>
    </ul>
  </div>
);
